/**
 * Centralised Google Analytics helper.
 *
 * Usage (Options API):
 *   import { trackEvent, setUserId } from '@/composables/useAnalytics';
 *   trackEvent('login', { method: 'email' });
 *
 * All calls are no-ops when gtag is not loaded (e.g. in development).
 */

export function trackEvent(eventName, params = {}) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

export function setUserId(userId) {
  if (typeof window.gtag === 'function') {
    window.gtag('set', { user_id: userId });
  }
}

export function setUserProperties(properties = {}) {
  if (typeof window.gtag === 'function') {
    window.gtag('set', 'user_properties', properties);
  }
}
